import { Box, Typography } from "@mui/material";

const Page404 = () => {
    return(
        <Box p={4} display="flex" justifyContent='center' alignItems="center" flexDirection="column">
            <Typography variant="h2">404</Typography>
            <Typography variant="h4">page not found</Typography>
        </Box>
    )
}

export default Page404;